<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid pb-3 container-content" [ngClass]="{'no-redirect': !content.dashboardRedirectPageFormId}">
    <ng-template [ngIf]="statusList?.length > 0 || employeeList?.length > 0">
      <div class="row" *ngFor="let item of statusList">
        <div class="col-12">
          <div class="flex-container">
            <div class="flex-item count-width">
              <span class="count">{{ item.value }}</span>
            </div>
            <div class="flex-item content-width">
              <span class="status" title="Employees on Probation Period">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <ng-template [ngIf]="content.employeeList">
        <div class="row py-2">
          <div class="col-12">
            <span class="employee-list-title">Recently Added Employees</span>
          </div>
        </div>
        <div class="row" *ngFor="let employee of employeeList">
          <div class="col-12">
            <div class="flex-container">
              <div class="flex-item img-width">
                <img [src]="employee.profilePicBase64 ? employee.profilePicBase64 : 'assets/profile.png'" alt="Profile picture" />
              </div>
              <div class="flex-item employee-list-content-width">
                <div>
                  <span class="name" title="{{ employee.name }}">{{ employee.name }}</span>
                </div>
                <div>
                  <span class="description">
                    <span class="float-left mr-3" title="Department: {{ employee.department ? employee.department : 'N/A'
                  }}">Department: {{ employee.department ? employee.department : 'N/A'
                      }}</span>
                    <span class="float-left mr-3" title="Designation: {{ employee.designation ? employee.designation : 'N/A'
                  }}">Designation: {{ employee.designation ? employee.designation : 'N/A'
                      }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!employeeList || employeeList.length === 0">
          <div class="col-12">
            <span class="no-data">No data available.</span>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <div class="row" *ngIf="(!statusList || statusList.length === 0) && (!employeeList || employeeList.length === 0)">
      <div class="col-12">
        <span class="no-data">No data available.</span>
      </div>
    </div>
  </div>
  <div class="row pb-3" *ngIf="content.dashboardRedirectPageFormId">
    <div class="col-12 text-center">
      <a class="link" (click)="footerRedirect()">{{ content.footerLink }}</a>
    </div>
  </div>
</div>
